<template>

	<div class="page-customers flex column" id="page-customers">
		<!-- <resize-observer @notify="__resizeHanlder" /> -->
		<el-row  >
			<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
				<div style="position:relative;float:right;">
					<el-radio-group v-model="modeModel" class="hidden-sm-and-down" size="small">
			      <el-radio-button label="list" style="padding:5px 0px 5px 0px;"><i class="mdi mdi-view-list" style="font-size:12px;"></i></el-radio-button>
			      <el-radio-button label="tile" style="padding:5px 0px 5px 0px;"><i class="mdi mdi-view-grid" style="font-size:12px;"></i></el-radio-button>
			    </el-radio-group>
		<el-button @click="openCustomerEditor" class="ml-10" size="small" type="primary" :disabled="!$can('write', 'Customer')"><span class="mdi mdi-plus-circle"> {{ $t('clients.create') }}</span></el-button>
		<el-dropdown size="small"   class="ml-10">
			<el-button  size="small">
				<i class="mdi mdi-download"></i>
			</el-button>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item @click.native="handleDownloadCSV('CSV_EXPORT', 'filtered')" :disabled="!$can('read', 'Customer')"> <span class="mdi mdi-download"> {{ $t('clients.downloadAllFilteredClients') }}</span></el-dropdown-item>
				<el-dropdown-item @click.native="handleDownloadCSV('CSV_EXPORT', 'full')" :disabled="!$can('read', 'Customer') || ( isStrictFilteredByRep && isCurrentUserRep)" > <span class="mdi mdi-download"> {{ $t('clients.downloadAllClients') }} </span></el-dropdown-item>
			
			</el-dropdown-menu>
      </el-dropdown>
	  <!-- <el-button @click="openCustomerEditor" type="primary" :disabled="!$can('write', 'Customer')"><span class="mdi mdi-plus"> {{ $t('clients.create') }}</span></el-button> -->
	  

				</div>
				<h2 class="mt-0" style="float:left;">{{ $t("clients.title") }}</h2>

			</el-col>

		</el-row>
		<el-row :gutter="20" style="margin-bottom:10px;">
			<el-col>
				<span class="fs-14 secondary-text">{{$t('common.total') }} : {{stats.count}} </span>
				<span class="fs-14 secondary-text" style="margin-left:20px;" v-if="isFiltered">{{$t('common.totalFiltered')}} : {{count}} <el-link type="text" @click="resetAllFilters"><i class="mdi mdi-filter-remove"/></el-link></span>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
					<!-- <el-tabs tab-position="top">
						<el-tab-pane label="Toutes les fiches"> -->
							<el-input
								:placeholder="$i18n.t('clients.search')"
								clearable
								v-model="customerSearch"
								v-popover:popover4>
                <el-dropdown slot="append" style="border-right:1px;">
                    <el-button type="primary">
                    {{$t('common.sortBy')}}<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :icon="sortIcon('usual_name')" @click.native="sortBy('usual_name')">{{$t('common.sortByItems.name')}}</el-dropdown-item>
                    <el-dropdown-item  :icon="sortIcon('createdAt')" @click.native="sortBy('createdAt')">{{$t('common.sortByItems.creationDate')}}</el-dropdown-item>
					<el-dropdown-item  :icon="sortIcon('lastSalesOrderDate')" @click.native="sortBy('lastSalesOrderDate')">Date dernière commande</el-dropdown-item>
					<el-dropdown-item  :icon="sortIcon('lastReservationDate')" @click.native="sortBy('lastReservationDate')">Date dernière réservation</el-dropdown-item>
                    <el-dropdown-item  :icon="sortIcon('notes.createdAt')" @click.native="sortBy('notes.createdAt')">{{$t('common.sortByItems.lastNoteTaken')}}</el-dropdown-item>
                    <el-dropdown-item  :icon="sortIcon('outstanding')" @click.native="sortBy('outstanding')">{{$t('common.sortByItems.outstanding')}}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
								<el-button slot="prepend" @click="showFilters=true"><i class="mdi mdi-filter"></i></el-button>
							</el-input>
							<div class="flex center m-10">
							<Pagination
								class="box right mt-5 mb-0 fs-14 secondary-text"
								:current-page="page"
								:total-number-of-page="pages"
								@click-previous="fetchPreviousPage"
								@click-next="fetchNextPage" />
							</div>
							<!-- <div class="box grow scrollable only-y item-list no-p" :style="getHeightStyle" v-loading="loading" v-if="mode=='tile'"></div> -->
							<div class="contacts-list" style="margin:10px;" >

									<div v-if="isTileMode" >
										<div class="box grow scrollable only-y item-list no-p" v-if="customers.length==0 && !loading" style="text-align: center;margin-top:50px;">{{ $t('clients.noCustomerFound') }}</div>

										<div class="box grow scrollable only-y item-list no-p" :style="getHeightStyle" v-loading="loading">

											<div v-for="c in customers" :key="c.id" class="flex contact" @click="openClient(c)" >
												<div class="star align-vertical p-10 fs-22">
													<el-tooltip v-if="c.type==0" content="Client particulier" placement="top">
														<i class="mdi mdi-account-circle align-vertical-middle"></i>
													</el-tooltip>
													<el-tooltip v-if="c.type==1" content="Client corporatif" placement="top">
														<i class="mdi mdi-city align-vertical-middle"></i>
													</el-tooltip>
												</div>
												<div class="info box grow flex">
													<div class="name box grow flex column justify-center p-10">
														<div class="fullname fs-18"><strong>{{getCustomerName(c)}}</strong></div>
														<div v-if="c.type==1">
															<div  v-for="contact in c.company.primaryContacts" :key="contact.id" style="margin-bottom:5px;margin-left:5px;padding-left:5px;" class="border-left">
																<div class="fullname fs-14 secondary-text">{{contact.first_name}} {{contact.last_name}}</div>
																<div class="email fs-14 secondary-text" v-if="contact.work_email">{{contact.work_email}}</div>
																<div class="email fs-14 secondary-text" v-else>{{contact.email}}</div>
																<div class="phone fs-14 secondary-text" v-if="contact.work_phone">{{contact.work_phone}} <span v-if="contact.work_phone_ext!=null && contact.work_phone_ext!=''"> Ext.: {{contact.work_phone_ext}}</span></div>
																<div class="phone fs-14 secondary-text" v-else>{{contact.phone}} <span v-if="contact.phone_ext!=null && contact.phone_ext!=''"> Ext.: {{contact.phone_ext}}</span></div>
															</div>
														</div>
														<div v-if="c.type==0" style="margin-bottom:5px;margin-left:5px;padding-left:5px;" class="border-left">
															<div class="email fs-14 secondary-text" v-if="getIndividualCustomerEmail(c)">{{getIndividualCustomerEmail(c)}}</div>
															<div class="phone fs-14 secondary-text" v-if="getIndividualCustomerPhone(c)">{{getIndividualCustomerPhone(c)}} <span v-if="getIndividualCustomerPhoneExt(c)"> Ext.: {{getIndividualCustomerPhoneExt(c)}}</span></div>
														</div>
                            <span class="fs-14 secondary-text" v-if="orderByModel.orderName === 'createdAt'">{{$t('clients.createdAtField')}} {{moment(c.createdAt)}}</span>
													</div>
													<div class="overdue align-vertical p-10" v-if="$can('write', 'Invoices')">
														<span class="align-vertical-middle" v-if="c.balance">{{$n(c.balance.outstanding, 'currency')}}</span>
														<el-tooltip class="item" effect="dark" content="Retard de paiement" placement="top">
															<span v-if="c.balance != null && c.balance.overdue > 0" class="mdi mdi-clock" style="color:#F56C6C"></span>
														</el-tooltip>
													</div>
												</div>
											</div>
										</div>
										<p class="fs-16 secondary-text" style="text-align:center" v-if="loading">Chargement...</p>
									</div>
									<div v-else :style="getWidthStyle">
											<el-table
									      		:data="customers"
												stripe
                        							
												:fit="true"
												:height="getHeight"
												:empty-text="$t('clients.noCustomerFound')"
									      		style="width: 100%;"
												v-loading="loading"
												>
									      <el-table-column prop="type" width="30" fixed>
													<template slot-scope="scope">
														<div>
															<el-tooltip v-if="scope.row.type==0" content="Client particulier" placement="top">
																<i class="mdi mdi-account-circle align-vertical-middle"></i>
															</el-tooltip>
															<el-tooltip v-if="scope.row.type==1" content="Client corporatif" placement="top">
																<i class="mdi mdi-city align-vertical-middle"></i>
															</el-tooltip>
														</div>
													</template>
									      </el-table-column>
									      <el-table-column
									        :label="$t('clients.name')"
                          					fixed
											width="300"
											:show-overflow-tooltip="true">
												<template slot-scope="scope">
												<PortausLink :label="getCustomerName(scope.row)" :id="scope.row.id" path="/customers/"></PortausLink>
												</template>
									      </el-table-column>
										  <el-table-column
									       		 label="Contact"  :show-overflow-tooltip="true" width="200">
														<template slot-scope="scope">
															<span>{{getPrincipalContactName(scope.row)}}</span>
														</template>
									      </el-table-column>
												
									      <el-table-column :label="$t('clients.class')"  :show-overflow-tooltip="true" width="150">
													<template slot-scope="scope">
														<span v-if="scope.row.class">{{scope.row.class.code}}</span>
													</template>
									      </el-table-column>
                        <el-table-column
									        :label="$t('clients.repShort')"
										  	width="60"
										
													:show-overflow-tooltip="true">
														<template slot-scope="scope">
															<vue-avatar v-if="scope.row.rep != null" :size="30" v-bind:username="getRepName(scope.row.rep)" :colors="COLORS_HSL"></vue-avatar>
														</template>
									      </el-table-column>
                        <el-table-column
                          :label="$t('clients.territory')"
						  width="200"
                          :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                             <span v-if="scope.row.territory != null">{{scope.row.territory.code}}</span>
                            </template>
                        </el-table-column>
							<el-table-column
								:label="$t('clients.tags')" width="150" :resizable="true" :show-overflow-tooltip="true">
								<template slot-scope="scope">
										<el-tag style="margin-right:5px;" v-for="tag in scope.row.tags" :key="tag.id" >{{tag.code}}&nbsp;</el-tag>
								</template>
							</el-table-column>
							<el-table-column
							v-if="$can('write', 'Invoices')"
							:label="$t('clients.stats.outstanding')" width="150" :show-overflow-tooltip="true" :resizable="true">
							<template slot-scope="scope">
								
								
								<span v-if="scope.row.balance">{{$n(scope.row.balance.outstanding, 'currency')}}</span>
								
								<el-tooltip class="item" effect="dark" content="Retard de paiement" placement="top">
									<span v-if="scope.row.balance != null && scope.row.balance.overdue > 0" class="mdi mdi-clock" style="color:#F56C6C"></span>
								</el-tooltip>
							</template>
						</el-table-column>
						<el-table-column
							:label="$t('clients.lastVisitDate')" :resizable="true" width="170">
							<template slot-scope="scope">
								<div v-if="getCustomerLastVisit(scope.row) != null">
									<span>{{moment(getCustomerLastVisit(scope.row), 'l')}}</span>
								</div>
								<span v-else> -- </span>
							</template>
						</el-table-column>
						<el-table-column
                        label="Dernière commande" :resizable="true" width="170">
                        <template slot-scope="scope">
							<div v-if="scope.row.lastSalesOrderDate != null">
								<span>{{moment(scope.row.lastSalesOrderDate, 'l')}}</span>
							</div>
							<span v-else> -- </span>
                        </template>
                      </el-table-column>
					  <el-table-column
                        label="Dernière Réserv." :resizable="true" width="170">
                        <template slot-scope="scope">
							<div v-if="scope.row.lastReservationDate != null">
								<span>{{moment(scope.row.lastReservationDate, 'l')}}</span>
							</div>
							<span v-else> -- </span>
                        </template>
                      </el-table-column>
						<el-table-column
                        label="Dernière note" :resizable="true" width="170">
                        <template slot-scope="scope">
							<div v-if="scope.row.lastNote != null">
								<span>{{moment(scope.row.lastNote.createdAt, 'l')}}</span>
								<el-popover
									placement="top-start"
									:title="$t('clients.lastNote')"
									width="200"
									trigger="click">
									<div style="word-break:normal;" >
										{{moment(scope.row.lastNote.createdAt, 'l')}}
										<div v-html="scope.row.lastNote.description"></div>
									</div>
									<el-button type="text" slot="reference" class="mdi mdi-eye-outline"></el-button>
								</el-popover>
							</div>
							<span v-else> -- </span>
                        </template>
                      </el-table-column>
											
									    </el-table>
									</div>

								</div>

						
			</el-col>
		</el-row>
		<customerFilter :visible="showFilters" direction="ltr" @close="showFilters=false"></customerFilter>
		<CustomerEditor :visible="customerEditorVisible" @close="closeCustomerEditor" @created=openClient></CustomerEditor>
	</div>
</template>

<script>

import InfoStatsCard from '@/components/Info-stat-card'
import moment from 'moment-timezone'
import customerFilter from './components/customer-filter'
import CustomerEditor from '@/components/customer/Customer-editor'
import customerAPI from '@/services/API/customer'
import PortausLink from '@/components/portaus-link'
import CustomerUtil from '@/utils/customer-util'
import Pagination from '@/components/pagination'
import VueAvatar from '@lossendae/vue-avatar'
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
	name: 'Clients',
	data() {
		return {
			COLORS_HSL : [
				[0, 0, 76],
			],
			firstCorporateCustomer : null,
			dialogvisible: false,
			pageWidth: 0,
			recentCustomers : [],
			showFilters : false,
			window: {
				width: 0,
				height: 0
			},
			customerEditorVisible : false,
			stats : {
				overdue : 0.00,
				outstanding : 0.00,
				draft : 0.00,
				count : 0,
			}

		}
	},
	computed: {
		isTileMode(){
			return this.mode=='tile';
		},
		getWidth() {
			return this.window.width - 350;
		},
		getHeight(){
			return (this.window.height-320);
			// if(this.window.height<897){
			// 	return this.window.height-203);
			// }else{
			// 	return this.window.height-340);
			// }
		},
		getHeightStyle(){
			return "height:" + this.getHeight + "px;";
		},
		getWidthStyle(){
			return "width:" + this.getWidth + "px;";
		},
    orderByModel : {
      set(val){this.setOrderBy(val)},
      get(){return this.orderBy}
    },
    sortIconModel : {
      set(val){this.setSortIcon(val)},
      get(){return this.sort_icon}
    },
		customerSearch : {
			set(val){this.setSearch(val);},
			get(){return this.search;}
		},
		checkedCustomerTypes :{
			set(val){this.$store.dispatch('CUSTOMER_CHANGE_CUSTOMER_TYPE_FILTER', val)},
			get(){return this.$store.getters.checkedCustomerTypes}
		},
		checkedActiveCustomers : {
			set(val){this.$store.dispatch('CUSTOMER_CHANGE_CUSTOMER_ACTIVE_FILTER', val)},
			get(){return this.$store.getters.checkedActiveCustomer}
		},
		checkedCustomerClasses :{
			set(val){this.$store.dispatch('CUSTOMER_CHANGE_CUSTOMER_CLASS_FILTER', val)},
			get(){return this.$store.getters.checkedCustomerClasses}
		},
		checkedTags : {
			set(val){this.$store.dispatch('CUSTOMER_CHANGE_CUSTOMER_TAGS_FILTER', val)},
			get(){return this.$store.getters.checkedCustomerTags}
		},
		currentPage : {
			set(val){},
			get(){return this.$store.getters.customers_page}
		},
		modeModel : {
			get(){ return this.mode},
			set(mode){this.changeMode(mode)}
		},
		...mapState('customers',['customers','list','mode','loading','pages','page','mode','search','outDated','count', 'sort_icon', 'orderBy']),
		...mapGetters('customers',['getPrincipalContactName','isFiltered']),
		...mapGetters(['isStrictFilteredByRep', 'isCurrentUserRep']),

	},
	watch : {
		outDated : function(val){
			if(this.$refs.infiniteLoading)this.$refs.infiniteLoading.stateChanger.reset();
		}
	},
	methods: {
	getRepName (rep) {
		if (rep == null) return null;
		return `${rep.firstName} ${rep.lastName}`;
	},
    getCustomerName(customer){
      return CustomerUtil.customerName(customer.name, customer.usualName, customer.type === 0);
    },
    getIndividualCustomerEmail(customer){
      if (customer) {
        return _.get(customer, 'contact.email');
      }
      return null;
    },
    getIndividualCustomerPhone(customer){
      if (customer) {
        return _.get(customer, 'contact.phone');
      }
      return null;
    },
    getIndividualCustomerPhoneExt(customer) {
      if (customer) {
        return _.get(customer, 'contact.phone_ext');
      }
      return null;
    },
		getCustomerLastVisit(customer) {
			if (customer == null) {
				return null;
			}
			return _.get(customer, 'lastVisit') || _.get(customer, 'last_visit') || null;
		},
    sortBy(orderName){

      if(this.orderByModel.orderName!=orderName){
        this.orderByModel={orderName : orderName, direction:'ASC'};
        this.sortIconModel = this.icons['ASC'];
      }else{
        if(this.orderByModel.direction=='DESC'){
          this.orderByModel={orderName : orderName, direction:'ASC'};
          this.sortIconModel = this.icons['ASC'];
        }else{
          this.orderByModel={orderName : orderName, direction:'DESC'};
          this.sortIconModel = this.icons['DESC'];
        }
      }
    },
    sortIcon(orderName){
      return orderName==this.orderBy.orderName?this.sort_icon:'';
    },
		loadStats(){
			customerAPI.fetchCustomers({stats:''})
				.then(stats=>{
					this.stats.overdue = stats.overdue;
					this.stats.outstanding = stats.outstanding;
					this.stats.draft = stats.draft;
				})
		},
		loadCount(){
			customerAPI.fetchCustomers({count:''})
				.then(stats=>{
					this.stats.count = stats.count;
				})
		},
		handleDownloadCSV(report, type) {
			return this.getQueryParams()
				.then((params) => {
					return customerAPI.downloadCustomerExtraction(report, type, params)
				})
		},
		openCustomerEditor(){
			this.customerEditorVisible=true;
		},
		closeCustomerEditor(){
			this.customerEditorVisible=false;
		},
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},
		moment(datetime, format='LLL'){
			return  moment(datetime).format(format);
		},
		openClient(client){
			var index = '/customers/' + client.id;
			this.$router.push(index)
			this.$emit('push-page', {page:index})
		},
		setPageWidth() {
			this.pageWidth = document.getElementById('page-customers').offsetWidth
		},
		handleCheckComponent(val){
			this.listCustomers();
		},
		...mapActions('controlData',['fetchCustomerClasses','fetchCustomerTags']),
		...mapActions('customers', ['fetchCustomers','fetchPreviousPage', 'fetchNextPage','changeMode','setSearch','invalidateList','resetAllFilters', 'setSortIcon','setOrderBy', 'getQueryParams']),

	},
	mounted() {
		this.fetchCustomerClasses();
		this.fetchCustomerTags();
		this.loadCount();
		this.loadStats();
		this.setPageWidth();
	},
	components: {
		InfoStatsCard,
		customerFilter,
		CustomerEditor,
		Pagination,
		VueAvatar,
    PortausLink
	},
	created(){
		window.addEventListener('resize', this.handleResize)
		this.handleResize();
		this.fetchCustomers();
	},
	destroyed() {
		this.invalidateList();
		window.removeEventListener('resize', this.handleResize)
	}
}
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/_variables';


.el-table .cell {
  white-space: nowrap;
  overflow: hidden;
	word-break:break-word;
}

.page-customers {
	height: 100%;
	margin: 0 !important;
	padding: 20px;
	padding-bottom: 10px;
	box-sizing: border-box;

	.search-card {
		padding: 50px;
		max-width: 350px;
		//max-height: 720px;
		box-sizing: border-box;
		margin-bottom: 15px;

		.el-input, .el-button {
			width: 100%;
		}
	}

	.search-wrap {
		margin: 0 auto;
		margin-bottom: 10px;
		padding: 0px 30px;
		box-sizing: border-box;
		width: 100%;
		max-width: 600px;

		i {
			display: inline-block;
			width: 22px;
		}

		input {
			outline: none;
			background: transparent;
			border: none;
			font-size: 15px;
			position: relative;
			top: -2px;
			width: 100%;
			padding: 0;
			color: $text-color;
		}

		.contacts-tot {
			margin-right: 20px;
			margin-left: 10px;
		}

		a {
			border-bottom: 1px solid;
			text-decoration: none;
			color: $text-color;

			&:hover {
				opacity: .6;
			}
		}
	}

	.contacts-root {
		max-height: 100%;
	}

	.avatar_user {
		border-radius: 50%;
		width: 35px;
		height: 35px;
		border: 1px solid #FFF;
		margin-left: 20px;
		box-sizing: border-box;
		display: block;
		cursor: pointer;
		box-shadow: 0 2px 5px 0 rgba(49,49,93,.1), 0 1px 2px 0 rgba(0,0,0,.08);
		transition: box-shadow .5s;

		&:hover {
			box-shadow: 0px 3px 10px 0 rgba(49, 49, 93, 0.08), 0px 2px 7px 0 rgba(0, 0, 0, 0.08);
		}
	}

	.contacts-list {
		//margin: 0 auto;
		// width: 100%;
		// max-width: 965px;
		padding: 0px 0px;
		box-sizing: border-box;

		.contact {
			margin: 10px 0;
			// padding: 5px;
			box-sizing: border-box;
			cursor: pointer;
			transition: all .5s .25s;

			.star {
				.mdi-star {
					color: #ffd730;
				}
				.mdi-star-outline {
					opacity: .5;
				}
			}

			.avatar {
				width: 60px;
				transition: all .5s .25s;

				img {
					border: 1px solid transparentize($text-color, .9);
					box-sizing: border-box;
					width: 50px;
					height: 50px;
					border-radius: 50%;
					transition: all .5s .25s;
				}
			}

			.info {
				word-break: break-word;

				.name {

					//.fullname {}

					//.email {
					//	opacity: 0;
					//	line-height: 0;
					//	transition: all .5s .25s;
					//}

					//.phone {
					//	opacity: 0;
					//	line-height: 0;
					//	transition: all .5s .25s;
					//}

					//.phone {
					//	display: none;
					//}
				}

				//.phone {}
			}

			&:hover {
				//margin: 15px -20px;
				//padding: 10px;
				background-color: lighten($background-color, 20%);
				border-radius: 5px;
				box-shadow: 0 8px 16px 0 rgba(40,40,90,.09),0 3px 6px 0 rgba(0,0,0,.065);

				.avatar {
					width: 90px;

					img {
						width: 90px;
						height: 90px;
					}
				}

				.info {
					.name {
						.email {
							opacity: 1;
							line-height: 1.4;
						}

						.phone {
							opacity: 1;
							line-height: 1.4;
						}
					}
				}
			}
		}
	}

	.contacts-root {
		&.medium {
			.search-card {
				padding: 20px;
				max-width: 260px;
				//max-height: 260px;
			}
		}
		&.small {
			overflow-y: auto;
			display: block;
			-webkit-box-orient: vertical;
			-webkit-box-direction: normal;
			-ms-flex-direction: column;
			flex-direction: column;
			padding: 5px;

			.search-card {
				padding: 20px;
				max-width: 100%;
				width: 100%;
				//max-height: 240px;
				flex: none;
				-webkit-box-flex: none;
				-ms-flex: none;
				display: block;
				overflow: hidden !important;
			}

			.contacts-list {
				flex: none;
				-webkit-box-flex: none;
				-ms-flex: none;
				display: block;
				overflow: hidden !important;
			}
		}
	}
}


@media (max-width: 768px) {

	.page-customers {
		.search-wrap {
			padding: 0;
		}
		.contacts-list {
			padding: 0px;

			.contact {
				.avatar {
					width: 40px;

					img {
						width: 40px;
						height: 40px;
					}
				}

				.info {
					.overdue {
						display: none;
					}

					.name {
						.phone {
							display: block;
						}
					}
				}

				&:hover {
					margin: 15px 0px;

					.avatar {
						width: 60px;

						img {
							width: 60px;
							height: 60px;
						}
					}
				}
			}
		}

		.contacts-root {
			&.medium {
				.contacts-list {
					padding: 0 30px;
				}
			}
			&.small {
				.contacts-list {
					padding: 8px;
				}
			}
		}
	}
}
</style>
